import './Footer.css';
import content from '../data/content.json';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3>{content.footer.brandName}</h3>
            <p>{content.footer.brandTagline}</p>
          </div>
          <div className="footer-info">
            <p>{content.footer.copyright}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
